import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { fetchGuestCompanyLandingInfo, clearGuestCompanyLandingInfo } from 'store/state/guest'
import styled from 'styled-components';
import Button from "@material-ui/core/Button";
import {ArrowBack} from '@material-ui/icons';
import { NavLink } from "react-router-dom";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import { downloadQuotesAsGuest } from "store/state/loan/loan";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import { AppBar, Tab, Tabs, Toolbar, Grid, TableCell } from "@material-ui/core";
import numberFormatter from 'utils/numberFormatter';
import _ from "lodash";
import moment from 'moment';

const styles = {
  root: {
    background: "#333333"
  },
};

const StyledTabs = styled(Tabs)`
&& {
  margin-top: 10px;
  border-radius: 0;
  color: #2196f3;
  background: none;
}
`

const StyledTab = styled(Tab)`
&& {
  margin-top: 10px;
  border-radius: 0;
  color: #2196f3;
  background: none;
}
`

const BlueButton = styled(Button)`
  && {
    margin-top: 10px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: #f6f6f6;
  }
  
`;

const HeaderText = styled.p`
  &&{
    font-size: 18pt;
    margin-left: 50px;
  }
`;

const PageBody = styled.div`
  &&{
    margin-left:50px;
    width: 80%;
    #border: 1px solid black;
  }
`;

const ButtonGroup = styled.div`
&&&&{
font-weight: bold;
}
`;

const formatDate = data => {
  if (!data) return '--';
  if (data === '-' || data === '--') return '--';

  if(data !== null)
    return moment.utc(data).format('MM/DD/YYYY');
  return '--'
}

export class GuestCompanyLanding extends Component {

    state = {
      pipelineDeals: [],
      pipelineWon: [],
      pipelineDead: [],
      portfolioClosed: [],
      portfolioSold: [],
      currentRender : "pipeline",
    }

    componentWillUnmount () {
      this.props.clearGuestCompanyLandingInfo();
    }

    tableColumnsPipeline = (props) => [
      {
        id: 'dealName',
        label: 'Deal',
        numeric: false,
        isString: true,
        isDateField: false,
        dataField:  'name',
        cellComponent: deal =>{
        if(deal.dealStatus.value.toLowerCase() == "dead" || this.state.currentRender.toLowerCase() == "pipelinewon"){
          return <span>{`${deal.name}`}</span>
        }else {
          return  (<NavLink exact to={`/deal/${deal.id}`}>
                    <span><b>{`${deal.name}`}</b></span>
                  </NavLink>)          
          }       
        }
      }, {
        id: 'City',
        label: 'City',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'city',
      }, {
        id: 'AssetType',
        label: 'Asset Type',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'assetType',
      }, {
        id: 'purchasePrice',
        label: 'Purchase Price',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'purchasePrice',
        cellComponent: deal => {
          const valueAsNumber = typeof deal.purchasePrice === 'string' ? Number(deal.purchasePrice.replace(/[^0-9.-]+/g,"")) : deal.purchasePrice;
          return (
            <TableCell>{`${numberFormatter.maskCurrency(valueAsNumber)}`}</TableCell>
          )
        }
      },{
        id: 'targetLoanAmount',
        label: 'Target Loan Amount',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'desiredLoanAmount',
        sortOverride: 'rawDesiredLoanAmount',
        cellComponent: deal => {
          const valueAsNumber = typeof deal.desiredLoanAmount === 'string' ? Number(deal.desiredLoanAmount.replace(/[^0-9.-]+/g,"")) : valueAsNumber;
          return (
            <TableCell>{`${numberFormatter.maskCurrency(valueAsNumber)}`}</TableCell>
          )
        }
      }, {
        id: 'targetedClosing',
        label: 'Target Close',
        numeric: false,
        isString: true,
        isDateField: true,
        isNotFilterable: true,
        dataField: 'targetedClosing',
        cellComponent: deal => {
          const value = formatDate(deal.targetedClosing);
          return (
            <TableCell>{value}</TableCell>
          )
        }
      },
      {
        id: 'Stage',
        label: 'Stage',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'stage',
      },{
        id: 'kebab',
        label: ' ',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        isSortable: false,
        isSearchable:false,
        cellComponent: deal =>
        (<OptionsMenu options={[{value:"Export Quote",id:1,onClick:()=>this.props.downloadQuotesAsGuest({dealId:deal.id})}]}/>)
      },
    ];

    tableColumnsDeadOrWon = (props) => [
      {
        id: 'dealName',
        label: 'Deal',
        numeric: false,
        isString: true,
        isDateField: false,
        dataField:  'name',
        cellComponent: deal =>{
        if(deal.dealStatus.value.toLowerCase() == "dead" || this.state.currentRender.toLowerCase() == "pipelinewon"){
          return <span>{`${deal.name}`}</span>
        }else {
          return  (<NavLink exact to={`/deal/${deal.id}`}>
                      <span><b>{`${deal.name}`}</b></span>
                    </NavLink>)           
          }       
        }
      }, {
        id: 'City',
        label: 'City',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'city',
      }, {
        id: 'AssetType',
        label: 'Asset Type',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'assetType',
      }, {
        id: 'purchasePrice',
        label: 'Purchase Price',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'purchasePrice',
        cellComponent: deal => {
          const valueAsNumber = typeof deal.purchasePrice === 'string' ? Number(deal.purchasePrice.replace(/[^0-9.-]+/g,"")) : valueAsNumber;
          return (
            <TableCell>{`${numberFormatter.maskCurrency(valueAsNumber)}`}</TableCell>
          )
        }
      },{
        id: 'targetLoanAmount',
        label: 'Target Loan Amount',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'desiredLoanAmount',
        sortOverride: 'rawDesiredLoanAmount',
        cellComponent: deal => {
          const valueAsNumber = typeof deal.desiredLoanAmount === 'string' ? Number(deal.desiredLoanAmount.replace(/[^0-9.-]+/g,"")) : valueAsNumber;
          return (
            <TableCell>{`${numberFormatter.maskCurrency(valueAsNumber)}`}</TableCell>
          )
        }
      }, {
        id: 'targetedClosing',
        label: 'Target Close',
        numeric: false,
        isString: true,
        isDateField: true,
        isNotFilterable: true,
        dataField: 'targetedClosing',
        cellComponent: deal => {
          const value = formatDate(deal.targetedClosing);
          return (
            <TableCell>{value}</TableCell>
          )
        }
      },
      {
        id: 'projectType',
        label: 'Project Type',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'projectType.value',
      },{
        id: 'kebab',
        label: ' ',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        isSortable: false,
        isSearchable:false,
        cellComponent: deal =>
        (<OptionsMenu options={[{value:"Export Quote",id:1,onClick:()=>this.props.downloadQuotesAsGuest({dealId:deal.dealId})}]}/>)
      },
    ];

    tableColumnsPortfolio = (props) => [
      {
        id: 'dealName',
        label: 'Deal',
        numeric: false,
        isString: true,
        isDateField: false,
        dataField:  'name',
        cellComponent: deal => {
          return  (<NavLink exact to={`/deal/${deal.id}`}>
                    <span><b>{`${deal.name}`}</b></span>
                   </NavLink>);
        }
      }, {
        id: 'lender',
        label: 'Lender',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'lender',
      }, {
        id: 'balance',
        label: 'Balance',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'balance',
        sortOverride: 'rawBalance',
        cellComponent: deal => {
          const valueAsNumber = typeof deal.balance === 'string' ? Number(deal.balance.replace(/[^0-9.-]+/g,"")) : valueAsNumber;
          return (
            <TableCell>{`${numberFormatter.maskCurrency(valueAsNumber)}`}</TableCell>
          )
        }
      }, {
        id: 'maturity',
        label: 'Maturity',
        numeric: false,
        isString: true,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'maturity',
      },{
        id: 'allInRate',
        label: 'All-In Rate',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'allInRate',
        sortOverride: 'rawAllInRate',
      }, {
        id: 'ltv',
        label: 'LTV',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'ltv',
        sortOverride: 'rawLtv',
      },
      {
        id: 'prepayment',
        label: 'Prepayment',
        numeric: true,
        isString: false,
        isDateField: false,
        isNotFilterable: true,
        dataField: 'prepayment',
        sortOverride: "rawPrepayment",
        cellComponent: deal => {
          const valueAsNumber = typeof deal.prepayment === 'string' ? Number(deal.prepayment.replace(/[^0-9.-]+/g,"")) : valueAsNumber;
          return (
            <TableCell>{`${numberFormatter.maskCurrency(valueAsNumber)}`}</TableCell>
          )
        }
      }
    ];


    componentDidMount(){
      this.props.fetchGuestCompanyLandingInfo({companyId: this.props.match.params.companyId});
      if(this.props.guest && this.props.guest.landingInfo && this.props.landingInfo.deals){
       this.refreshStateDeals();
      }
    }

    componentDidUpdate(prevProps, prevState){
      if(prevProps.token !== this.props.token){
        this.refreshStateDeals();
      }
      if((!prevProps.landingInfo && this.props.landingInfo) ||
      (prevProps.landingInfo != null && prevProps.landingInfo.company.id !== this.props.landingInfo.company.id)){
        this.refreshStateDeals();
      }
      if(prevState.pipelineDeals.length !== this.state.pipelineDeals.length ||
        prevState.pipelineDead.length !== this.state.pipelineDead.length ||
        prevState.pipelineWon.length !== this.state.pipelineWon.length ||
        prevState.portfolioClosed.length !== this.state.portfolioClosed.length ||
        prevState.portfolioSold.length !== this.state.portfolioSold.length){
          this.setToActiveTab();
        }
    }

    refreshStateDeals(){
      const newState = {
        pipelineDeals: [],
        pipelineWon: [],
        pipelineDead: [],
        portfolioClosed: [],
        portfolioSold: [],
      }
      const deals = this.props.landingInfo.deals;
      delete deals.__dataRedacterIgnore__;
      const keys = Object.keys(deals);
      this.formatDealValues(deals);

      keys.forEach((key) => {
        const deal = deals[key];
        if(!deal.dealStatus)return;
        switch (deal.dealStatus.value.toLowerCase()){
          case "closed":
            newState.portfolioClosed.push(deal);
            break;
          case "sold":
            newState.portfolioSold.push(deal);
            break;
          case "pipeline":
            newState.pipelineDeals.push(deal);
            break;
          case "dead":
            if(!deal.isWon) newState.pipelineDead.push(deal);
            break;
          case "refinance":
            newState.pipelineDeals.push(deal);
            newState.portfolioClosed.push(deal);
            break;
          default:
            break;
        }
        if(deal.isWon){
          newState.pipelineWon.push(deal);
        }
      })
      this.setState({
        pipelineDeals: newState.pipelineDeals,
        pipelineDead: newState.pipelineDead,
        portfolioClosed: newState.portfolioClosed,
        portfolioSold: newState.portfolioSold,
        pipelineWon: newState.pipelineWon
      });
    }

    formatDealValues(deals) {
      const SENIOR = "c779ef59-4691-11e9-82f6-0242ac120002"; 
      const keys = Object.keys(deals);
      keys.forEach((key) => {
        const deal = deals[key];
        if (deal.formatted) return;
        deal.formatted = true;
        if (!deal.stage) {
          deal.stage = "-";
        } else {
          deal.stage = deal.stage.value;
        }

        
          if ((!deal.properties || deal.properties.length===0)) {
            if(!deal.city) deal.city = "-";
            !deal.assetTypeName ? deal.assetType = "-" : deal.assetType = deal.assetTypeName;
            if(!deal.purchasePrice) deal.purchasePrice = "-";
          } else {
            _.sortBy(deal.properties,"purchaseDate");
            deal.city = deal.properties[0].city;
            deal.assetType = deal && deal.properties[0] && deal.properties[0].assetTypeRef ? deal.properties[0].assetTypeRef.value : null;
            deal.purchasePrice = deal && deal.properties[0] && deal.properties[0].purchasePrice ? deal.properties[0].purchasePrice.value : null;
          }
        
        if (deal.targetedClosing) {
          deal.targetedClosing = deal.targetedClosing.split("T")[0];
        } else {
          deal.targetedClosing = "-";
        }
        if(deal.targetLoanAmount){
          deal.desiredLoanAmount = deal.targetLoanAmount;
        }
        if (!deal.desiredLoanAmount) {
          deal.desiredLoanAmount = "-";
          deal.rawDesiredLoanAmount = Math.NEGATIVE_INFINITY;
        }else{
          deal.rawDesiredLoanAmount = deal.desiredLoanAmount;
          deal.desiredLoanAmount = `$${deal.desiredLoanAmount}`;
        }
        if (!deal.allInRate) {
          deal.allInRate = "-";
        }
        if (deal.ltv===null) {
          deal.ltv = "-";
          deal.rawLtv = -Number.MAX_VALUE;
        } else {
          deal.rawLtv = deal.ltv;
          deal.ltv = `${deal.ltv}%`
        }
        if (!deal.prepayment) {
          deal.prepayment = "-";
          deal.rawPrepayment = Number.NEGATIVE_INFINITY; //no prepayment will always be on the *very* bottom of the sorted list
        } else if (deal.prepayment !== 'LOCKOUT') {
          deal.rawPrepayment = deal.prepayment;
          deal.prepayment = `$${deal.prepayment}` 
        }else{
          deal.rawPrepayment = -Number.MAX_VALUE; //lockout will sort below deals with a prepayment value but above deals without a prepayment value
        }
        if (!deal.loans || deal.loans.length === 0) {
          deal.lender = "-";
          deal.balance = "-";
          deal.maturity = "-";
        } else {
          const qualifiedLoans = [];
          deal.loans.forEach(loan=>{
            if(loan.loanSeniorityId==SENIOR && loan.loanProvider && loan.loanProvider.length>0){
              qualifiedLoans.push(loan);
            }
          });
          if (qualifiedLoans.length > 0) {
          _.sortBy(qualifiedLoans,["closingDate"]);
          deal.lender = qualifiedLoans[0].loanProvider && qualifiedLoans[0].loanProvider[0].name ? qualifiedLoans[0].loanProvider[0].name : "-";
          deal.balance = qualifiedLoans[0].currentPrincipalBalance ? `$${qualifiedLoans[0].currentPrincipalBalance}` : "-";
          deal.rawBalance = qualifiedLoans[0].currentPrincipalBalance ? qualifiedLoans[0].currentPrincipalBalance : -Number.MAX_VALUE;
          deal.maturity = qualifiedLoans[0].maturityDate ? qualifiedLoans[0].maturityDate : "-";
          }else{
            deal.lender = "-";
            deal.balance = "-";
            deal.maturity = "-";
          }
        }
      });       
    }

    setToActiveTab(){
      if (this.state.pipelineDeals.length < 1) { //pipelineDeals is default so only check if its disqualified
        if (this.state.pipelineWon.length > 0) {
          this.setState({currentRender:"pipelinewon"});
          return null;
        }else{
          if (this.state.pipelineDead.length > 0) {
            this.setState({currentRender:"pipelinedead"});
            return null;
          } else {
            if (this.state.portfolioClosed.length > 0) {
              this.setState({currentRender:"portfolioclosed"});
              return null;
            } else {
              if (this.state.portfolioSold.length > 0) {
                this.setState({currentRender:"portfoliosold"});
                return null;
              }
            }
          }
        }
      }
    }
    
    render(){
      if(this.state.pipelineDeals.length === 0 && this.state.pipelineDead.length === 0 &&
        this.state.portfolioClosed.length === 0 && this.state.portfolioSold.length === 0 &&
        this.props.landingInfo && this.props.landingInfo.deals && this.props.landingInfo.deals.length > 0){
          this.refreshStateDeals();
        }
        let rows = null;
        let currentRender = this.state.currentRender.toLowerCase();
        let columnDef = null;
        switch(currentRender.toLowerCase()){
          case "pipeline":
            rows = this.state.pipelineDeals;
            columnDef = this.tableColumnsPipeline();
            break;
          case "pipelinedead":
            rows = this.state.pipelineDead;
            columnDef = this.tableColumnsDeadOrWon();
            break;
          case "pipelinewon":
            rows = this.state.pipelineWon;
            columnDef = this.tableColumnsDeadOrWon();
            break;
          case "portfolioclosed":
            rows = this.state.portfolioClosed;
            columnDef = this.tableColumnsPortfolio();
            break;
          case "portfoliosold":
            rows = this.state.portfolioSold;
            columnDef = this.tableColumnsPortfolio();
            break;
        }
        
        return (
        <Fragment>
          <BlueButton style={{fontWeight:"bold"}} onClick={this.props.history.goBack}>
            <ArrowBack/><span>BACK TO PREVIOUS PAGE</span>
          </BlueButton>
          <HeaderText>{`${this.props.landingInfo ? this.props.landingInfo.company.name : ""}`}</HeaderText>
          <PageBody>
          <AppBar position="static" color="inherit">
          <Grid container spacing={8} alignItems="center">
            <Toolbar
              style={{
                justifyContent: "flex-start",
                minHeight: "50px",
                width:"100%",
                paddingLeft:0,
                marginBottom: !rows || rows.length === 0 ? "10px" : ""
              }}
            >
              <StyledTabs
                value={this.state.currentRender.toLowerCase()}
                onChange={(event, value)=>this.setState({currentRender:value})}
                indicatorColor="primary"
                textColor="primary"
              >
                <StyledTab
                  key={0}
                  value={'pipeline'}
                  id="pipelineTab"
                  label="PIPELINE"
                  style={{fontWeight: this.state.currentRender=="pipeline" ? "bold" : ""}}
                 />
                <StyledTab
                  key={1}
                  value={"pipelinewon"}
                  id="pipelinewon"
                  label="PIPELINE WON"
                  style={{fontWeight: this.state.currentRender=="pipelinewon" ? "bold" : ""}}
                  />
                  <StyledTab
                  key={2}
                  value={"pipelinedead"}
                  id="pipelinedead"
                  label="PIPELINE DEAD"
                  style={{fontWeight: this.state.currentRender=="pipelinedead" ? "bold" : ""}}
                  />
                  <StyledTab
                  key={3}
                  value={"portfolioclosed"}
                  id="portfolioclosed"
                  label="PORTFOLIO CLOSED"
                  style={{fontWeight: this.state.currentRender=="portfolioclosed" ? "bold" : ""}}
                  />
                  <StyledTab
                  key={4}
                  value={"portfoliosold"}
                  id="portfoliosold"
                  label="PORTFOLIO SOLD"
                  style={{fontWeight: this.state.currentRender=="portfolioSold" ? "bold" : ""}}
                  />
              </StyledTabs>
            </Toolbar>
          </Grid>
        </AppBar>
          <EnhancedTable
                columnDefinitions={columnDef ? columnDef : []}
                rows={rows ? rows : []}
                orderBy={this.tableColumnsPipeline()[0]}
                order={EnhancedTable.DESC_ORDER}
                shouldHideConfig={true}
                shouldHideExport={true}
                useGridLayout
                searchHintText="Search"
                width={'99%'}
                overflowY={"inherit"}                
                pageable
                rowsPerPage={10}
                tableConfigItemId="7c079b7f-b592-40b0-a3bb-4ace25d0c416"
                noRowsMessage="No Deals Found"
                showLoadingIndicator = {!this.props.landingInfo}
                />
          
          </PageBody>
        </Fragment>)
    }

}


const mapStateToProps = ({ authentication, guest }) => ({
    authentication,
    invitedToCompanies: guest.invitedToCompanies,
    landingInfo : guest.guestCompanyLandingInfo,
    token: guest.landingToken,
  });
  
  export default compose(
    connect(mapStateToProps,{
      fetchGuestCompanyLandingInfo,
      clearGuestCompanyLandingInfo,
      downloadQuotesAsGuest
    }),
    withStyles(styles),
  )(GuestCompanyLanding);